<div class="print-view-container">
  <span class="print-view-title">{{title}}</span>
  <span class="button-container">
    <a class="print-view-button" (click)="printPage()">Print</a>&nbsp;&nbsp;
    <a class="print-view-cancel" (click)="cancel()">Cancel</a>&nbsp;&nbsp;
  </span>
</div>
<div class="print-result-container">
  <fm-table #dt [columns]="columns" [value]="data"
            [enableTableEntryTotal]="true">
    <ng-template fmTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" class="row-selection">{{col.header}}</th>
      </tr>
    </ng-template>
    <ng-template fmTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [style.width]="col.width">
          {{rowData[col.field]}}
        </td>
      </tr>
    </ng-template>
  </fm-table>
</div>

